import { extend } from 'flarum/common/extend';
import DiscussionComposer from 'flarum/forum/components/DiscussionComposer';
import app from 'flarum/forum/app';

/**
 * 修改 ComposerBody-header 的 item-title 文案
 */
export default function modifyComposerTitle() {
  // 修改 DiscussionComposer 的 headerItems 方法
  extend(DiscussionComposer.prototype, 'headerItems', function (items) {
    // 替换 'title' 项为 "New topic"
    items.replace('title', <h3 className="item-title">New topic</h3>, 100);
    
    return items;
  });
  
  // 使用 DOM 操作作为备用方案（确保在动态更新时也能生效）
  const updateComposerTitle = () => {
    // 查找 ComposerBody-header 内的第一个 h3 元素（item-title）
    const titleElement = $('.ComposerBody--discussion .ComposerBody-header h3:first-child');
    if (titleElement && titleElement.length) {
      const currentText = titleElement.text().trim();
      
      // 如果不是 "New topic"，则修改
      if (currentText && currentText !== 'New topic') {
        titleElement.text('New topic');
      }
    }
  };
  
  // 修改 item-tags 内的 TagLabel untagged 文案
  const updateTagLabel = (composer) => {
    // 查找 item-tags 内的 TagLabel untagged
    const tagLabelElement = $('.ComposerBody--discussion .ComposerBody-header .item-tags .TagLabel.untagged, .ComposerBody--discussion .ComposerBody-header .DiscussionComposer-changeTags .TagLabel.untagged');
    if (tagLabelElement && tagLabelElement.length) {
      const currentText = tagLabelElement.text().trim();
      
      // 如果不是 "Groups"，则修改
      if (currentText && currentText !== 'Groups') {
        tagLabelElement.text('Groups');
      }
    }
    
    // 为 DiscussionComposer-changeTags 添加 placeholder 属性
    const changeTagsLink = $('.ComposerBody--discussion .ComposerBody-header .DiscussionComposer-changeTags');
    if (changeTagsLink && changeTagsLink.length) {
      // 检查是否有 untagged 类，如果有说明没有选择标签
      const hasUntagged = changeTagsLink.find('.TagLabel.untagged').length > 0;
      if (hasUntagged) {
        // 如果没有选择标签，显示 placeholder
        changeTagsLink.attr('data-placeholder', 'Select the group you want to post in');
        changeTagsLink.removeClass('has-tags');
      } else {
        // 如果已选择标签，不显示 placeholder
        changeTagsLink.attr('data-placeholder', '');
        changeTagsLink.addClass('has-tags');
      }
    }
  };
  
  // 监听 Composer 显示事件
  extend(DiscussionComposer.prototype, 'oncreate', function () {
    setTimeout(() => {
      updateComposerTitle();
      updateTagLabel(this);
    }, 0);
  });
  
  // 监听 Composer 更新事件
  extend(DiscussionComposer.prototype, 'onupdate', function () {
    setTimeout(() => {
      updateComposerTitle();
      updateTagLabel(this);
    }, 0);
  });
  
  // 使用 MutationObserver 监听 ComposerBody-header 的变化
  const setupComposerObserver = (composer) => {
    const composerHeader = composer.$('.ComposerBody-header');
    if (composerHeader && composerHeader.length) {
      // 如果已经设置了 observer，先断开
      if (composerHeader.data('title-observer')) {
        composerHeader.data('title-observer').disconnect();
      }
      
      // 创建 MutationObserver 监听子元素变化
      const observer = new MutationObserver(() => {
        updateComposerTitle();
        updateTagLabel(composer);
      });
      
      // 开始观察 ComposerBody-header 的子元素变化
      observer.observe(composerHeader[0], {
        childList: true,
        subtree: true,
        characterData: true
      });
      
      // 保存 observer 引用
      composerHeader.data('title-observer', observer);
    }
  };
  
  // 在 Composer 显示时设置 observer
  extend(DiscussionComposer.prototype, 'oncreate', function () {
    setTimeout(() => {
      setupComposerObserver(this);
    }, 100);
  });
  
  // 清理 observer 当 Composer 销毁时
  extend(DiscussionComposer.prototype, 'onremove', function () {
    const composerHeader = this.$('.ComposerBody-header');
    if (composerHeader && composerHeader.length) {
      const observer = composerHeader.data('title-observer');
      if (observer) {
        observer.disconnect();
        composerHeader.removeData('title-observer');
      }
    }
  });
}

